import React from "react";
import PropTypes from "prop-types";
import {Icon, Layout, Menu} from "antd";
import {compose} from 'recompose';
import {connect} from "react-redux";
import {NavLink} from "react-router-dom";
import {withRouter} from "react-router";
import logo from "../img/Logo-green-aPureBase-geen.png";
import logoCollapse from "../img/Logo-green-aPureBase-geen-collapsed.png";
const {Content, Sider} = Layout;
const SubMenu = Menu.SubMenu;


class AppLayout extends React.Component {

    state = {
        collapsed: false
    };

    toggle = (collapsed) => this.setState({
        collapsed
    });

    render() {
        const {children, location} = this.props;
        const {collapsed} = this.state;
        const active = location.pathname; //.slice(1).split('/')[0];
        const displayLogo = collapsed ? logoCollapse : logo;
        return <Layout style={{minHeight: '100vh'}}>
            <Sider collapsible collapsed={collapsed} onCollapse={this.toggle}
                   style={{overflow: 'auto', height: '100vh', position: 'fixed', left: 0}}>
                <div className={collapsed ? 'logo-collapsed' : 'logo-maximize'}>
                    <img className={collapsed ? 'collapsed' : 'maximize'}  src={displayLogo} alt="aPureBase Logo" />
                </div>

                <Menu theme="dark" mode="inline" style={{lineHeight: '64px'}} selectedKeys={[active]}>
                    <Menu.Item key="/browse/person">
                        <NavLink to="/browse/person">
                            <Icon type="user"/>
                            <span>Browse Persons</span>
                        </NavLink>
                    </Menu.Item>
                    <Menu.Item key="/browse/site">
                        <NavLink to="/browse/site">
                            <Icon type="home"/>
                            <span>Browse Sites</span>
                        </NavLink>
                    </Menu.Item>
                    <SubMenu title={<span><Icon type="area-chart"/><span>Statistics</span></span>}>
                    <Menu.Item key="/browse/import">
                        <NavLink to="/browse/import">
                            <span>Import Statistics</span>
                        </NavLink>
                    </Menu.Item>
                        <Menu.Item key="/browse/selection">
                            <NavLink to="/browse/selection">
                                <span>Selection Statistics</span>
                            </NavLink>
                        </Menu.Item>
                    </SubMenu>
                    <SubMenu title={<span><Icon type="fork"/><span>Global LOVs</span></span>}>
                        <Menu.Item key="/lov/manage/AP_PERS_SUBSPC">
                            <NavLink to="/lov/manage/AP_PERS_SUBSPC">
                                <span>Manage</span>
                            </NavLink>
                        </Menu.Item>
                        <Menu.Item key="/lov/map">
                            <NavLink to="/lov/map">
                                <span>Lov Mapper</span>
                            </NavLink>
                        </Menu.Item>
                        <Menu.Item key="/lov/lovResult">
                            <NavLink to="/lov/lovResult">
                                <span>Lov Result</span>
                            </NavLink>
                        </Menu.Item>
                    </SubMenu>
                    <Menu.Item key="/selection/builder">
                        <NavLink to="/selection/builder">
                            <Icon type="select" />
                            <span>Selection</span>
                        </NavLink>
                    </Menu.Item>
                    <Menu.Item key="/browse/customer">
                        <NavLink to="/browse/customer">
                            <Icon type="table" />
                            <span>Browse Customers</span>
                        </NavLink>
                    </Menu.Item>
                    <Menu.Divider />
                    <Menu.Item key="/logout">
                        <NavLink to="/logout">
                            <Icon type="logout"/>
                            <span>Logout</span>
                        </NavLink>
                    </Menu.Item>
                </Menu>
            </Sider>
            <Layout style={{marginLeft: collapsed ? 80 : 200}}>
                <Layout>
                    <Content style={{background: '#fff', minHeight: 400}}>
                        {children}
                    </Content>

                </Layout>
            </Layout>
        </Layout>
    }

}

AppLayout.propTypes = {
    email: PropTypes.string,
    loggedIn: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
    email: state.auth.email,
    loggedIn: state.auth.loggedIn,
});

export default compose(
    withRouter,
    connect(mapStateToProps, null),
)(AppLayout);



// WEBPACK FOOTER //
// ./src/js/AppLayout.js